import mime from "mime";

export const base64ToFile = (base64: string, filename: string): File => {
	let mimeType = "";
	let base64Data = "";

	const matches = base64.match(/^data:(.*?);base64,/);

	if (matches) {
		mimeType = matches[1];
		base64Data = base64.replace(/^data:(.*?);base64,/, "");
	} else {
		mimeType = mime.getType(filename) || "application/octet-stream";
		base64Data = base64;
	}

	const byteString = atob(base64Data);

	const byteArray = new Uint8Array(byteString.length);

	for (let i = 0; i < byteString.length; i++) {
		byteArray[i] = byteString.charCodeAt(i);
	}

	const blob = new Blob([byteArray], { type: mimeType });

	return new File([blob], filename, { type: mimeType });
};
